<template>
  <section>
    <inner-surevy-page-header
      :links="links"
      :surveyData="surveyData"
      :type="'RED'"
    />

    <mode-filter></mode-filter>

    <div class="survey-charts-container mt-4 pb-4" ref="surveyChartsContainer">
      <router-view></router-view>
    </div>
  </section>
</template>

<script>
import ModeFilter from "@/components/dashboard/surveys-charts/individual/mode-filter.vue";
import { mapGetters } from "vuex";
import InnerSurevyPageHeader from "../../../components/dashboard/surveys-charts/shared/inner-surevy-page-header.vue";

export default {
  name: "SurveyInformation",
  components: {
    ModeFilter,
    InnerSurevyPageHeader,
  },
  data() {
    return {
      componentName: "SurveyUnDemographics",
      showFilter: false,
      links: [
        {
          routeName: "SurveyCoreQuestions",
          text: "Experience",
          linkParams: { id: this.surveyId },
        },
        {
          routeName: "SurveyDemographicQuestions",
          text: "Demographics",
          linkParams: { id: this.surveyId },
        },
        {
          routeName: "SurveyComments",
          text: "comments",
          linkParams: { type: "RED", id: this.surveyId },
        },
      ],
    };
  },
  computed: {
    ...mapGetters("mainStats", {
      surveyData: "getSurveyWithModesById",
    }),

    runTime() {
      return `${this.formatDate(
        this.surveyData.publishDate
      )} - ${this.formatDate(this.surveyData.endDate)}`;
    },

    responseRate() {
      return `Response: ${this.surveyData.total}`;
    },

    medianResponseTime() {
      return `Median Response Time:
            ${Math.round(this.surveyData.avgDuration)}min`;
    },
    surveyId() {
      return this.$route.params.id;
    },
  },
  methods: {
    handleScroll(event) {
      if (event.target.scrollTop > 700) {
        this.showFilter = true;
      } else {
        this.showFilter = false;
      }
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch("mainStats/resetDataUsedInd3");
      await this.$store.dispatch("mainStats/loadSurveyWithModesById", {
        surveyId: this.$route.params.id,
        multiSurvey: false,
        surveyType: "RED",
      });

      await this.$store.dispatch("mainStats/fetchExperienceDistributionRED", {
        surveyId: this.$route.params.id,
      });

      await this.$store.dispatch("mainStats/fetchSurveyExperienceDrivers", {
        surveyId: this.$route.params.id,
        multiSurvey: false,
      });

      await this.$store.dispatch("mainStats/fetchSurveyQuestionAnswers", {
        surveyId: this.$route.params.id,
        isDemographic: false,
        multiSurvey: false,
      });

      await this.$store.dispatch("mainStats/fetchSurveyCommentsCount", {
        surveyId: this.$route.params.id,
        multiSurvey: false,
      });

      await this.$store.dispatch("mainStats/fetchSurveyLanguageBreakdown", {
        surveyId: this.$route.params.id,
      });

      await this.$store.dispatch("mainStats/fetchSurveyQuestionAnswers", {
        surveyId: this.$route.params.id,
        isDemographic: true,
        multiSurvey: false,
        surveyType: "RED",
      });
    } catch (error) {
      this.$store.dispatch("dialog/showErrorDialog", {
        error: error,
      });
    }
  },

  destroyed() {
    this.$store.dispatch("mainStats/resetStore");
  },
};
</script>

<style lang="scss" scoped>
.survey-charts-container {
  height: calc(100vh - 16.3rem);
  overflow: auto;
  padding-right: 1rem;
}

.mode-filter {
  transition: $transition-200ms;
  opacity: 1;
  visibility: visible;
}
</style>
